import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteeTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const OnGoingGuarantees = ({ TabsRaw }: any) => (
  <GuaranteeTableRecords
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.ongoingGuaranteesRoute}
    tabStatus="ONGOING"
    toggleStorageId="ongoing-guarantee-table-col"
    hasNameAndImage
    permissionName="can-view-paid-guarantees"
  />

);

export default OnGoingGuarantees;
